import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { AccordionHeader } from '@/components/Accordion/AccordionHeader';
import { AccordionBody } from '@/components/Accordion/AccordionBody';

@Component
export class AccordionContainer extends ThemeComponent {
    @Prop({default: false}) open!: boolean;
    @Prop header!: string;
    @Prop content!: string;
    @Prop({default: 'plus-minus'}) icons!: 'plus-minus' | 'chevrons';
    @Prop({default: 'left'}) iconPosition!: 'left' | 'right';

    @Ref accordionHeader!: AccordionHeader;
    @Ref accordionBody!: AccordionBody;

    init() {
        this.$subscribe(this.accordionHeader.onOpenChange, this.toggleOpen.bind(this));
    }

    private toggleOpen() {
        this.classList.toggle('accordion--open');
    }
}
